var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:[{'py-5 px-4': !_vm.wgFullscreen}],staticStyle:{"margin":"0px auto"},attrs:{"id":"content-card","tile":_vm.wgFullscreen,"width":_vm.width2,"height":_vm.height2}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }